
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useRoomServices = (roomId?: string) => {
  return useQuery({
    queryKey: ['room-services', roomId],
    queryFn: async () => {
      if (!roomId) return [];
      
      const { data, error } = await supabase
        .from('services')
        .select('*')
        .eq('room_id', roomId);

      if (error) {
        console.error('Error fetching room services:', error);
        throw error;
      }

      return data || [];
    },
    enabled: !!roomId,
  });
};
